import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProgressReportHttpCallsService {
  dynamicUrl: any;
  secondpagelist: any;
  class: any;
  stream: any;
  campusTrackId: any;
  token: string | number | (string | number)[];
  testCodeWiseResults(jwt: any, scaitsWebServiceUrl: any, payload:any) {
    const headers = new HttpHeaders({
      'Authorization': jwt,
    });

    const params = new HttpParams()
      .set('admNo', payload.admNo)
      .set('testCode', payload.testCode);

    return this.http.post(
      `${scaitsWebServiceUrl}/studentProgressReport/testCodeWiseResults`, 
      {},
      { headers, params }
    );
  }
  

  constructor( private http:HttpClient) { }
  latestExamResult(token: string, scaitsurl: string, admNo: string) {
    const headers = new HttpHeaders({
      'Authorization': token,
    });
  
    const params = new HttpParams().set('admNo', admNo);
  
    return this.http.post(scaitsurl + '/studentProgressReport/latestExamResult', {}, { headers, params });
  }
latestStudentMarksList(token: string, scaitsurl: string, admNo: string) {
  const headers = new HttpHeaders({
    'Authorization': token,
  });

  const params = new HttpParams().set('admNo', admNo);

  return this.http.post(scaitsurl + '/studentProgressReport/studentMarksDTOList', {}, { headers, params });
}
  loadTestTypeWiseRankDetails(jwt: any, scaitsWebServiceUrl: any, payload:any) {
    const headers= new HttpHeaders({
      'Authorization': jwt,
    });
    const params = new HttpParams()
    .set('admNo', payload.admNo)
    .set('testType', payload.testType);

  return this.http.post(
    `${scaitsWebServiceUrl}/studentProgressReport/testTypeLatestExamResult`, 
    {},
    { headers, params }
  );
  }

  loadTestTypeWiseSubjectPerformance(jwt: any, scaitsWebServiceUrl: any, payload:any) {
    const headers= new HttpHeaders({
      'Authorization': jwt,
    });
    const params = new HttpParams()
    .set('admNo', payload.admNo)
    .set('testType', payload.testType);

  return this.http.post(
    `${scaitsWebServiceUrl}/studentProgressReport/testTypeLatestExamResult`, 
    {},
    { headers, params }
  );
  
  }

  loadTestTypeWiseTestModePerformance(jwt: any, scaitsWebServiceUrl: any, payload:any) {
    const headers= new HttpHeaders({
      'Authorization': jwt,
    });
    const params = new HttpParams()
    .set('admNo', payload.admNo)
    .set('testType', payload.testType);

  return this.http.post(
    `${scaitsWebServiceUrl}/studentProgressReport/testTypeWiseTestModePerformance`, 
    {},
    { headers, params }
  );

  }


  loadTestTypeWiseExamPerfornamce(jwt: any, scaitsWebServiceUrl: any, payload:any) {
    const headers= new HttpHeaders({
      'Authorization': jwt,
    });
    const params = new HttpParams()
    .set('admNo', payload.admNo)
    .set('testType', payload.testType);

    return this.http.post(
      `${scaitsWebServiceUrl}/studentProgressReport/testTypeWiseExamPerformance`, 
      {},
      { headers, params }
    );
    
  }
  loadTestTypeAndTestCodeList(jwt: any, scaitsWebServiceUrl: any, payload:any) {
    const headers = new HttpHeaders({
      'Authorization': jwt,
    });

    const params = new HttpParams()
    .set('admNo', payload.admNo)
    .set('testType', payload.testType);

    return this.http.post(
      `${scaitsWebServiceUrl}/studentProgressReport/testTypeWiseTestCodes`, 
      {},
      { headers, params }
    );
  }
  loadTestTypeWiseExamPerformance(jwt: any, scaitsWebServiceUrl: any, payload:any) {
    const headers = new HttpHeaders({
      'Authorization': jwt,
    });

    const params = new HttpParams()
    .set('admNo', payload.admNo)
    .set('testType', payload.testType);

    return this.http.post(
      `${scaitsWebServiceUrl}/studentProgressReport/testTypeLatestExamResult`, 
      {},
      { headers, params }
    );
  }
studentSearch(jwt: any, scaitsWebServiceUrl: any,payload:any)
{
  const headers = new HttpHeaders({
    'Authorization': jwt,
  });

  // const params = new HttpParams()
  // .set('admNo', payload.admNo)
  // .set('testType', payload.testType);

  return this.http.post(
    `${scaitsWebServiceUrl}/studentProgressReport/getStudentSearchInfoV3`, 
    payload,
    { headers}
  );
}
getStudentDetails(scaitsWebServiceUrl:any,token:any,admno:any) {
  this.dynamicUrl = `${scaitsWebServiceUrl}/studentProgressReport/studentdetails?admNo=`+admno;
  const headers= new HttpHeaders({
    'Authorization': token,
  });
  return this.http.get(this.dynamicUrl, { headers });
}
 getTestTypeWiseExamResults(scaitsWebServiceUrl:any,testType:any,admNo:any)
 {
  this.dynamicUrl = `${scaitsWebServiceUrl}/studentProgressReport/testtypewiseexamresults?admNo=`+admNo+`&testType=`+testType;
  const headers= new HttpHeaders({
    // 'Authorization': token,
  });
  return this.http.get(this.dynamicUrl, { headers });
 }

 getBanners(scaitsWebServiceUrl:any,admNo:any)
 {
  this.dynamicUrl = environment.employeeURL+`/jwtV2/api/getBannerDetails?admNo=`+admNo;
  const headers= new HttpHeaders({
    // 'Authorization': token,
  });
  return this.http.get(this.dynamicUrl, { headers });
 }

 getPdf(admNo:any){
  this.dynamicUrl = environment.employeeURL+`/jwtV2/api/employee/studentProgressReport/generateProgressReportPdf?admNo=`+admNo;
  const headers= new HttpHeaders({
    // 'Authorization': token,
  });
  return this.http.get<Blob>(this.dynamicUrl, { headers, responseType: 'blob' as 'json' });
 }
}
